import { Table, ButtonDelete } from '@digital/ui';
import React, { useState, useMemo, useEffect } from 'react';
import { Switch, Icon, Collapse, Tooltip } from 'antd';
import { deletTipoModuloModuloPerfilAcessoPermissao, Permissoes, TipoModuloPerfilPermissao } from '@app/api/moduloPerfilPermissao';


interface TabelaTipoModuloProps {
    moduloId: string,
    tipoModuloPerfilPermissao: TipoModuloPerfilPermissao,
    permissoes: Permissoes[],
    atualizarGrid(): void
}

const TabelaTipoModulo = (props: TabelaTipoModuloProps) => {

    const { tipoModuloPerfilPermissao, permissoes, moduloId, atualizarGrid } = props;
    const [allTipoPermissao, setAllTipoPermissao] = useState<TipoModuloPerfilPermissao[]>();
    const [permissoesResult, setPermissoes] = useState<Permissoes[]>();


    useEffect(() => {
        setPermissoes(permissoes)
    }, [permissoes]);

    const deletPermissao = (tipoModuloModuloPerfilAcessoPermissaoId: string) => {
        deletTipoModuloModuloPerfilAcessoPermissao(tipoModuloModuloPerfilAcessoPermissaoId).then(() => { atualizarGrid() });
    }

    return (
        <>
            <Table
                dataSource={permissoesResult}                
                columns={[
                    {
                        title: 'N',
                        dataIndex: 'index',
                    },
                    {
                        title: 'Descrição',
                        dataIndex: 'nome',
                    },
                    {
                        title: 'Codigo',
                        dataIndex: 'codigo',
                    },
                    {
                        title: 'Ações',
                        render: (row, record, index) => {
                            return <>

                                <Tooltip title="Deletar Item">
                                    <ButtonDelete
                                        type="link"
                                        confirm="Deseja realmente excluir este registro?"
                                        okText="Confirmar"
                                        onClick={() => {
                                            deletPermissao(record.id)
                                        }}
                                        icon="science-minus"
                                        className="btn-delete-without-text"
                                    />
                                </Tooltip>
                            </>
                        },
                        width: '5%'
                    }
                ]}
            />
        </>
    )

}

export default TabelaTipoModulo;